export const CURRENCY = '£'
export const PRODUCT_META_FIELDS = (metadata) => {
  return [
    metadata.fruit,
    metadata.size,
  ]
}

export default {
  CURRENCY,
  PRODUCT_META_FIELDS,
}